import React from 'react'
import Footer from '../components/Footer'
import HeroImage from '../components/HeroImage'
import Navbar from '../components/Navbar'
import ProvinceCards from '../components/provincecards/ProvinceCards'
import '../components/provincecards/ProvinceCards.css'
import Banner from '../components/Banner';



const Contact = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='Venue' text='More information below on where to find us.' />
            <ProvinceCards />
            <Banner />
            <Footer/>
        </div>
    )
}

export default Contact
